import { useMemo } from 'react';
import { parseNotificationMessage } from '../../utils/notificationMessage';

type Props = {
  message: string;
  className?: string;
};

/** Renders notification message content as React elements (HTML email → paragraphs). */
export default function NotificationMessageBody({ message, className = 'nc-body' }: Props) {
  const paragraphs = useMemo(() => {
    const { text } = parseNotificationMessage(message);
    if (!text) return [];
    return text.split(/\n\n+/).map((part) => part.trim()).filter(Boolean);
  }, [message]);

  if (paragraphs.length === 0) return null;

  if (paragraphs.length === 1) {
    return <div className={className}>{paragraphs[0]}</div>;
  }

  return (
    <div className={className}>
      {paragraphs.map((part, index) => (
        <p key={index} style={index > 0 ? { marginTop: '0.5em', marginBottom: 0 } : { margin: 0 }}>
          {part}
        </p>
      ))}
    </div>
  );
}
